import {GetFavouritesCallback} from "@next/eventservice"

export const getFavourtiesSubscriptionCallBack = (
    cb: (...args: any[]) => void,
    setFavouritedColourways: (...args: any[]) => any,
) => {
    const getFavCallback = new GetFavouritesCallback()

    const callBack = data => {
        getFavCallback.UnsubscribeAll()
        cb(data, setFavouritedColourways)
    }

    return getFavCallback.subscribe(callBack)
}
